var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _line, _line2, _rect5, _rect6, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar4Red(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#FF5B5B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 43,
    width: 56,
    height: 7,
    rx: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1045 46.3921C11.1088 46.1842 11.1953 45.9865 11.3453 45.8425L16.1502 41.2168C16.2242 41.1452 16.3116 41.0889 16.4075 41.0512C16.5033 41.0135 16.6056 40.9951 16.7086 40.9971C16.8115 40.999 16.9131 41.0213 17.0074 41.0626C17.1017 41.1039 17.1869 41.1635 17.2582 41.2378L21.8839 46.0427C22.0278 46.1926 22.1065 46.3934 22.1025 46.6011C22.0986 46.8088 22.0124 47.0065 21.8628 47.1507L17.0579 51.7764C16.9081 51.9204 16.7073 51.999 16.4996 51.9951C16.2918 51.9911 16.0941 51.9049 15.9499 51.7554L11.3242 46.9505C11.1799 46.8008 11.1009 46.6 11.1045 46.3921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5869 47.602C16.3683 47.5979 16.1558 47.529 15.9763 47.4041C15.7968 47.2791 15.6584 47.1038 15.5785 46.9002C15.4987 46.6966 15.481 46.4739 15.5278 46.2603C15.5745 46.0467 15.6835 45.8517 15.8411 45.7C15.9986 45.5484 16.1976 45.4468 16.4128 45.4082C16.6281 45.3697 16.8499 45.3958 17.0504 45.4833C17.2508 45.5708 17.4207 45.7158 17.5387 45.8999C17.6567 46.084 17.7175 46.2989 17.7134 46.5176C17.7078 46.8108 17.586 47.0897 17.3747 47.2931C17.1635 47.4965 16.8801 47.6076 16.5869 47.602Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1045 46.3921C50.1088 46.1842 50.1953 45.9865 50.3453 45.8425L55.1502 41.2168C55.2242 41.1452 55.3116 41.0889 55.4075 41.0512C55.5033 41.0135 55.6056 40.9951 55.7086 40.9971C55.8115 40.999 55.9131 41.0213 56.0074 41.0626C56.1017 41.1039 56.1869 41.1635 56.2582 41.2378L60.8839 46.0427C61.0278 46.1926 61.1065 46.3934 61.1025 46.6011C61.0986 46.8088 61.0124 47.0065 60.8628 47.1507L56.0579 51.7764C55.9081 51.9204 55.7073 51.999 55.4996 51.9951C55.2918 51.9911 55.0941 51.9049 54.9499 51.7554L50.3242 46.9505C50.1799 46.8008 50.1009 46.6 50.1045 46.3921Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5869 47.602C55.3683 47.5979 55.1558 47.529 54.9763 47.4041C54.7968 47.2791 54.6584 47.1038 54.5785 46.9002C54.4987 46.6966 54.481 46.4739 54.5278 46.2603C54.5745 46.0467 54.6835 45.8517 54.8411 45.7C54.9986 45.5484 55.1976 45.4468 55.4128 45.4082C55.6281 45.3697 55.8499 45.3958 56.0504 45.4833C56.2508 45.5708 56.4207 45.7158 56.5387 45.8999C56.6567 46.084 56.7175 46.2989 56.7134 46.5176C56.7078 46.8108 56.586 47.0897 56.3747 47.2931C56.1635 47.4965 55.8801 47.6076 55.5869 47.602Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7446 20.6648C18.8864 20.2662 19.2637 20 19.6867 20H52.3133C52.7363 20 53.1136 20.2662 53.2554 20.6648L57.5249 32.6648C57.7566 33.3158 57.2738 34 56.5828 34H15.4172C14.7262 34 14.2434 33.3158 14.4751 32.6648L18.7446 20.6648Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 6,
    height: 4,
    rx: 1,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 28,
    width: 6,
    height: 4,
    rx: 1,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.6708,
    y1: 30.2236,
    x2: 13.2236,
    y2: 33.3292,
    stroke: "black",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 3.97214,
    y2: -0.5,
    transform: "matrix(-0.447214 0.894427 0.894427 0.447214 61 30)",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 21,
    height: 0.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 21,
    height: 0.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.148 56.997C29.1197 56.997 29.5667 56.2868 29.9257 55.7166C30.2709 55.1732 30.4625 54.9171 30.7662 54.9171C31.07 54.9171 31.2633 55.1732 31.605 55.7166C31.964 56.2868 32.4093 56.997 33.3827 56.997C34.3561 56.997 34.8014 56.2868 35.1604 55.7166C35.5055 55.1732 35.6954 54.9171 35.9991 54.9171C36.3029 54.9171 36.4945 55.1732 36.8396 55.7196C37.1986 56.2898 37.6456 57 38.6173 57C39.589 57 40.036 56.2898 40.395 55.7196C40.7402 55.1762 40.93 54.9201 41.2338 54.9201C41.5375 54.9201 41.7308 55.1762 42.0726 55.7196C42.4316 56.2898 42.8786 57 43.8502 57C44.8219 57 45.2689 56.2898 45.6279 55.7196C45.9731 55.1762 46.1629 54.9201 46.4667 54.9201C46.6081 54.9201 46.7438 54.8716 46.8438 54.7854C46.9438 54.6991 47 54.5821 47 54.46C47 54.338 46.9438 54.221 46.8438 54.1347C46.7438 54.0485 46.6081 54 46.4667 54C45.495 54 45.048 54.7087 44.689 55.2804C44.3438 55.8238 44.154 56.0799 43.8502 56.0799C43.5465 56.0799 43.3532 55.8238 43.0115 55.2804C42.6525 54.7087 42.2055 54 41.2338 54C40.2621 54 39.8151 54.7087 39.4561 55.2804C39.1109 55.8238 38.9194 56.0799 38.6173 56.0799C38.3153 56.0799 38.1203 55.8238 37.7785 55.2804C37.4195 54.7087 36.9725 54 36.0009 54C35.0292 54 34.5822 54.7087 34.2232 55.2804C33.878 55.8238 33.6864 56.0799 33.3844 56.0799C33.0824 56.0799 32.8856 55.8238 32.5456 55.2804C32.1849 54.7087 31.7396 54 30.7679 54C29.7963 54 29.3475 54.7087 28.9885 55.2804C28.6434 55.8238 28.4535 56.0799 28.1498 56.0799C27.846 56.0799 27.6527 55.8238 27.311 55.2804C26.952 54.7087 26.505 54 25.5333 54C25.3919 54 25.2562 54.0485 25.1562 54.1347C25.0562 54.221 25 54.338 25 54.46C25 54.5821 25.0562 54.6991 25.1562 54.7854C25.2562 54.8716 25.3919 54.9201 25.5333 54.9201C25.8371 54.9201 26.0304 55.1762 26.3721 55.7196C26.7293 56.2868 27.1746 56.997 28.148 56.997Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar4Red);
export default __webpack_public_path__ + "static/media/Car4_Red.738bda600e94ed61dfa0eca1ee5ed2f6.svg";
export { ForwardRef as ReactComponent };